import types from "./types";

const InitialState = {
  departmentList: [],
  isFetchingDepartments: false,
  departmentListError: "",

  organizationList: [],
  isFetchingOrgList: false,
  orgListError: "",
};

export default (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case types.GET_ORG_LIST_REQUEST:
      return {
        ...state,
        isFetchingOrgList: action.isFetchingOrgList,
      }
    case types.GET_ORG_LIST_COMPLETE:
      return {
        ...state,
        isFetchingOrgList: action.isFetchingOrgList,
        organizationList: action.organizationList
      }
    case types.GET_ORG_LIST_ERROR:
      return {
        ...state,
        isFetchingOrgList: action.isFetchingOrgList,
        orgListError: action.orgListError
      }

    case types.GET_ORG_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
      }
    case types.GET_ORG_DEPARTMENTS_COMPLETE:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departmentList: action.departmentList
      }
    case types.GET_ORG_DEPARTMENTS_ERROR:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departmentListError: action.departmentListError
      }
    default: return state;
  }
}
